import * as React from "react";
import styled from "styled-components";
import { BasicLegend2 } from "../basic-legend-2";
// tslint:disable-next-line:variable-name
const Root = styled(BasicLegend2) `
  table {
    height: 100%;
    margin: auto;
    .item {
      cursor: pointer;
      &:hover {
        background-color: ${p => p.colorPalette.blackColor[1]};
      }
      &.not-active {
        .color {
          background-color: gray;
        }
      }
      height: 24px;
      justify-content: center;
      td {
        padding: 0;
        /* 解决不可消失的padding问题 */
        font-size: 0;
      }
      .color {
        width: 4px;
        height: 8px;
        margin: 7px 8px 7px 12px;
        display: inline-block;
        border-radius: 2px;
      }
      .name {
        font-size: 12px;
        line-height: 24px;
        display: inline-block;
        margin-right: 12px;
      }
    }
  }
`;
// tslint:disable-next-line:variable-name
const Color = styled.div `
  background-color: ${props => props.color};
`;
/**
 * 分类图层大屏版本
 *
 * @author 张卓诚
 * @export
 * @class ClassificationLegend3
 * @extends {(React.PureComponent<ClassificationLegend3Props<T> & ColorProps<GlobalColorPalette> & ICSSProps>)}
 * @implements {Color<GlobalColorPalette>}
 * @implements {ICSS}
 * @implements {(Legend<ClassificationLegend3Props<T> & BasicLegendProps>)}
 * @template T
 */
export class ClassificationLegend3 extends React.PureComponent {
    render() {
        return (React.createElement(Root, { theme: this.props.theme, style: this.props.style, className: this.props.className, colorPalette: this.props.colorPalette, title: this.props.title, unit: this.props.unit },
            React.createElement("table", null,
                React.createElement("tbody", null, this.props.colors.map((item, index) => (React.createElement("tr", { key: item.key, className: "item" + (item.show === false ? " not-active" : ""), onClick: () => this.props.toggle !== undefined
                        ? this.props.toggle(item.key)
                        : undefined },
                    React.createElement("td", null,
                        React.createElement(Color, { className: "color", color: item.color })),
                    React.createElement("td", null,
                        React.createElement("div", { className: "name" }, this.props.names[index])))))))));
    }
}
ClassificationLegend3.defaultProps = {
    theme: "dark",
};
//# sourceMappingURL=index.js.map